import styled, {
  Button,
  Scale,
  TypographyVariant,
  typographyVariantProperties,
} from '@secretescapes/falcon';
import { mediaQuery } from 'src/app/utils/styles.utils';

export const Container = styled('div')`
  display: flex;

  flex-direction: row;
  gap: ${Scale.l};
  @media ${mediaQuery.tablet} {
    gap: ${Scale.m};
  }
`;
interface ItemButtonProps {
  isActive: boolean;
}

export const ItemButton = styled(Button)<ItemButtonProps>`
  padding: ${Scale.s} 0 !important;
  > span {
    font-size: ${typographyVariantProperties[TypographyVariant.body].desktopFontSize};
  }

  border-bottom: ${({ theme, isActive }) =>
    `${Scale.xxxs} solid ${isActive ? theme.color.blackText : `transparent`} !important`};
  ${({ theme, isActive }) =>
    isActive ? `> span { font-weight: bold; }` : `> span { color: ${theme.color.grey}; }`}

  &:hover:not(:disabled):not(:active) {
    background: unset;
  }

  &:active:not(:disabled) {
    background: unset;
    box-shadow: none;
  }
`;
